import {EddlMergedAbstract} from '@app/services/analytics/EDDL/events/eddl-merged.abstract';

export class EddlCartViewEvent extends EddlMergedAbstract {
  static readonly type = 'EddlCartViewEvent';
}
